import { render } from "./block-proposals.vue?vue&type=template&id=e2544a79"
import script from "./block-proposals.vue?vue&type=script&lang=js"
export * from "./block-proposals.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__